module.exports = __webpack_public_path__ + "static/media/underdogbannersmall.d166dc8f.png";